@if (useChips == false) {
  <nts-base-text-box
    #baseTextBox
    [ngClass]="{ 'to-user-validation': propertyViewModel.isToUserValidation }"
    [isDisabled]="!(filter.isEnabled$ | async) || !(propertyViewModel.isEnabled$ | async)"
    [maxLength]="$safeNavigationMigration(getStringZoomPropertyViewModel()?.maxLength)"
    [value]="propertyViewModel.value$ | async"
    [maskSettings]="maskSettings"
  (onValueChange)="valueChange($event)"></nts-base-text-box>
}
@if (useChips == true) {
  <nts-base-chips-box
    #baseChipsBox
    [isDisabled]="!(filter.isEnabled$ | async) || !(propertyViewModel.isEnabled$ | async)"
    (onValueChange)="valueChangeForChips($event)"
    [addOnBlur]="true"
    [value]="valueForChips"
    [validateBeforeAddFunc]="validateChipsFunc"
  [maskSettings]="maskSettings"></nts-base-chips-box>
}